import React from "react";
import Logo from "../../../containers/assets/LandingPageLogo3.png";

function TeamReportsTwoColumnsLayout({
  title = "",
  left_content = null,
  right_content = null
}) {
  return (
    <div className="team-reports-layout team-reports-one-column clearfix">
      <div className="left">
        <div className="team-reports-logo without-border">
          <img src={Logo} alt="logo" />
          <div className="orange-line" />
          <div className="green-line" />
        </div>
        <div className="title">{title}</div>
        <div className="one-column-inner-content">{left_content}</div>
      </div>
      <div className="right">{right_content}</div>
    </div>
  );
}

export default TeamReportsTwoColumnsLayout;



// WEBPACK FOOTER //
// ./src/components/team-reports/layouts/two-columns.js